module.exports = __webpack_public_path__ + "img/pdf.af5c7594.svg";